import { Tabs } from 'antd';
import { TabsType } from 'antd/lib/tabs';
import React, { ReactNode, useCallback } from 'react';
import { ReactElement } from 'react';

export default function HashTabs(props: {
    children: ReactNode;
    defaultActiveKey: string;
    type?: TabsType;
}): ReactElement {
    const {
        children,
        defaultActiveKey,
        type,
    } = props;

    const onChangeTab: (activeKey: string) => void = useCallback((activeKey: string): void => {
        window.location.hash = activeKey;
    }, []);

    return (
        <Tabs
            activeKey={window.location.hash.replace('#', '') || defaultActiveKey}
            onChange={onChangeTab}
            type={type}
        >
            {children}
        </Tabs>
    );
}